import { Chip } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

/**
 * Status badge component for claim statuses
 * Uses semantic color tokens from the theme
 *
 * @param {Object} props
 * @param {string} props.label - The display label for the status
 * @param {string} props.size - Size of the chip ('small' | 'medium')
 * @returns {JSX.Element}
 */
const UsedInBadge = ({ label, size = "tiny" }) => {
  // Map backend status values to chip variant names

  const defaultColor = "secondary";
  const labelColorMap = {
    Rechnung: "primary",
    "Rechnung/Bestätigung": "primary",
    "Mietvertrag / Bestätigung aktueller Mietpreis": "primary",
    "Forderungsschreiben des Mieters": "primary",
    "Abtretungserklärung (Dokument)": "primary",
    "polizeiliche Meldung": "info",
  };

  const color = labelColorMap[label] || defaultColor;

  // Custom styling for tiny size
  const tinySx =
    size === "tiny"
      ? {
          fontSize: "0.7rem",
          height: 20,
        }
      : {};

  return (
    <Chip
      label={label}
      variant="outlined"
      color={color}
      size={size === "tiny" ? "small" : size}
      sx={tinySx}
    />
  );
};

UsedInBadge.propTypes = {
  label: PropTypes.string.isRequired,
  source: PropTypes.string,
  size: PropTypes.oneOf(["tiny", "small"]),
};

export default UsedInBadge;
